import { render } from "./ReleaseLotsModal.vue?vue&type=template&id=251385ec&scoped=true&ts=true&lang=pug"
import script from "./ReleaseLotsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReleaseLotsModal.vue?vue&type=script&lang=ts&setup=true"

import "./ReleaseLotsModal.vue?vue&type=style&index=0&id=251385ec&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251385ec"]])

export default __exports__